import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CreateEventDisciplinesForm, CreateEventForm } from '../types';

@Component({
  selector: 'app-event-management-basic-details',
  templateUrl: './event-management-basic-details.component.html',
  styleUrls: ['./event-management-basic-details.component.scss'],
})
export class EventManagementBasicDetailsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  protected readonly Object = Object;
  private subscriptions = new Subscription();

  @Input() innerForm: FormGroup<CreateEventForm>;
  @Input() disciplinesForm: FormGroup<CreateEventDisciplinesForm>;

  public fragmentChangeScrolling: boolean = false;
  public BASIC_DETAILS_STEPS = {
    BASIC_INFO: {
      id: 'basic-info',
      title: 'event_management_basic_info',
    },
    SPORTS_AND_DISCIPLINES: {
      id: 'sport-and-disciplines',
      title: 'event_management_sport_and_disciplines',
    },
    LOCATION: {
      id: 'location',
      title: 'event_management_location',
    },
  };

  public activeBasicDetailsStep: string =
    this.BASIC_DETAILS_STEPS.BASIC_INFO.id;

  private requiredFields: (keyof CreateEventForm)[] = [
    'event_name',
    'event_organization_id',
    // 'event_short_description',
    'event_start_date',
    'event_start_time',
    'event_finish_date',
    'event_finish_time',
    'event_location',
  ];

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    Object.keys(this.innerForm.controls).forEach((controlName: string) => {
      const control = this.innerForm.get(controlName);

      if (this.requiredFields.includes(controlName as keyof CreateEventForm)) {
        control?.addValidators(Validators.required);
      }
    });

    this.subscriptions.add(
      this.route.fragment.subscribe((fragment) => {
        if (fragment) {
          const config = Object.values(this.BASIC_DETAILS_STEPS).find(
            (item) => item.id === fragment
          );

          if (config) {
            this.preventScrollNavigation();
            this.activeBasicDetailsStep = config.id;
          }
        }
      })
    );
  }

  ngAfterViewInit(): void {
    this.preventScrollNavigation();
  }

  preventScrollNavigation(): void {
    this.fragmentChangeScrolling = true;

    setTimeout(() => {
      this.fragmentChangeScrolling = false;
    }, 900);
  }

  navigateTo(fragment: string): void {
    let keepActiveStep = '';

    this.route.queryParams.forEach(({ step }) => {
      if (!keepActiveStep && step) {
        keepActiveStep = step;
      }
    });

    this.preventScrollNavigation();
    this.router.navigate([], {
      queryParams: {
        step: keepActiveStep,
      },
      fragment,
    });
    this.activeBasicDetailsStep = fragment;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
